/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DomainRecruiterNewDriverDriverSegment } from '../../entities/domain/RecruiterNewDriverDriverSegment'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const domainRecruiterNewDriverDriverSegmentSchema = z.enum(['new', 'reactivated']) as unknown as ToZod<DomainRecruiterNewDriverDriverSegment>